export enum FileFolderType {
  Default = 0,
}
